import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { Product } from '../../domain/product';
import { PrimeNGConfig } from 'primeng/api';
import {MenuItem,PrimeIcons} from 'primeng/api';

@Component({
  selector: 'app-create-job-chain',
  templateUrl: './create-job-chain.component.html',
  styleUrls: ['./create-job-chain.component.scss']
})
export class CreateJobChainComponent implements OnInit {
    items: MenuItem[];
    availableProducts: Product[];
    
    selectedProducts: Product[];
    
    draggedProduct: Product;

    products: Product[];
    
    constructor(private productService: ProductService, private primengConfig: PrimeNGConfig) { }
    
    ngOnInit() {
        this.selectedProducts = [];
        this.productService.getProductsSmall().then(products => this.availableProducts = products);
        this.items = [
            {label: 'Menu'},
            {label: 'Menu Active'},
          ];
    }
    
    dragStart(product: Product) {
        this.draggedProduct = product;
    }
    
    drop() {
        if (this.draggedProduct) {
            let draggedProductIndex = this.findIndex(this.draggedProduct);
            this.selectedProducts = [...this.selectedProducts, this.draggedProduct];
            this.availableProducts = this.availableProducts.filter((val,i) => i!=draggedProductIndex);
        }
    }
    
    
    
    findIndex(product: Product) {
        let index = -1;
        for(let i = 0; i < this.availableProducts.length; i++) {
            if (product.id === this.availableProducts[i].id) {
                index = i;
                break;
            }
        }
        return index;
    }

}
